import { BrowserRouter, Route, Routes   } from "react-router-dom";
import Home from "./pages/Home";
import Landing from "./pages/Landing";
import Products from "./pages/Products";
import ProductsHealthcare from "./pages/ProductsHealthcare";
import ProductsCommercial from "./pages/ProductsCommercial";
import OrderPage from "./pages/Order";
import Contact from "./pages/Contact";
import Support from "./pages/Support";
import Downloads from "./pages/Downloads";
import Careers from "./pages/Careers";
import About from "./pages/About";
import PartnerZone from "./pages/PartnerZone";
import SearchResults from "./pages/SearchResults";
import ErrorPage from "./pages/ErrorPage";
import ProductsDetails from "./pages/ProductsDetails";
import {useState} from 'react'
import ScrollToTop from './components/ScrollToTop';
import { Navigate } from "react-router-dom";
import "./App.scss";

function App() {
    const [scroll,setScroll]=useState(false)
    const scrollHandler =()=>{
        window.scrollY > 90 ? setScroll(true):setScroll(false) ;
    }
    window.addEventListener('scroll', scrollHandler)
  return (
    <BrowserRouter>
          <ScrollToTop />
          <Routes errorElement={<ErrorPage scroll={scroll}/>}>
              <Route path="/" element={<Home scroll={scroll} />} errorElement={<ErrorPage scroll={scroll}/>}/> 
              <Route path="/landing" element={<Landing scroll={scroll} />} errorElement={<ErrorPage scroll={scroll}/>}/>
              <Route path="/products" element={<Products scroll={scroll} />} errorElement={<ErrorPage scroll={scroll}/>}/>
              <Route path="/products/products_healthcare" element={<ProductsHealthcare scroll={scroll} />} errorElement={<ErrorPage scroll={scroll}/>}/>
              <Route path="/products/products_commercial" element={<ProductsCommercial scroll={scroll} />} errorElement={<ErrorPage scroll={scroll}/>}/>
              <Route path="/order" element={<OrderPage scroll={scroll} />} errorElement={<ErrorPage scroll={scroll}/>}/>
              <Route path="/contact" element={<Contact scroll={scroll} />} errorElement={<ErrorPage scroll={scroll}/>}/>
              <Route path="/support" element={<Support scroll={scroll} />} errorElement={<ErrorPage scroll={scroll}/>}/>
              <Route path="/downloads" element={<Downloads scroll={scroll} />} errorElement={<ErrorPage scroll={scroll}/>}/>
              <Route path="/careers" element={<Careers scroll={scroll} />} errorElement={<ErrorPage scroll={scroll}/>}/>
              <Route path="/about" element={<About scroll={scroll} />} errorElement={<ErrorPage scroll={scroll}/>}/>
              <Route path="/products/:ID" element={<ProductsDetails scroll={scroll} />} errorElement={<ErrorPage scroll={scroll}/>}/>
              <Route path="/partner_zone" element={<PartnerZone scroll={scroll} />} errorElement={<ErrorPage scroll={scroll}/>}/>
              <Route path="/search" element={<SearchResults scroll={scroll} />} errorElement={<ErrorPage scroll={scroll}/>}/>
              <Route path="/404" element={ <ErrorPage scroll={scroll}/>} />
              <Route path="*" element={ <Navigate to="/404" replace />} />
          </Routes>
    </BrowserRouter>
  );
}

export default App;
